import styled from 'styled-components'
import { camelCase, noop } from 'lodash'
import { createModal, useModalize } from '@/components/modalize/mui'
import { Button } from '@/components/button'
import { colors } from '@/styles'
import ContractCreatedIcon from './contract-created-icon.svg'
import DeleteContractIcon from './delete-contract-icon.svg'
import TrashRedIcon from './trash-red-icon.svg'
import CautionIcon from './caution-icon.svg'
import UploadDocumentIcon from './upload-document-icon.svg'

const Container = styled.div`
  width: 100%;
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.backgroundColor};
  height: 112px;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 24px;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  > *:not(:last-child) {
    margin-right: 5px;
  }
`

const Title = styled.h5`
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
`

const Paragraph = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: ${colors.grey48};
  text-align: left;
`

const icons = {
  yourProgressWillBeLost: <img src={CautionIcon} alt="icon" />,
  documentsLocked: <img src={CautionIcon} alt="icon" />,
  documentCreated: <img src={ContractCreatedIcon} alt="icon" />,
  contractSent: <img src={ContractCreatedIcon} alt="icon" />,
  areYouSureYouWantToDeleteThisContract: <img src={DeleteContractIcon} alt="icon" />,
  areYouSureYouWantToDeleteAllDocuments: <img src={DeleteContractIcon} alt="icon" />,
  areYouSureYouWantToDeleteThisDocument: <img src={DeleteContractIcon} alt="icon" />,
  areYouSureYouWantToWithdrawAllContracts: <img src={DeleteContractIcon} alt="icon" />,
  areYouSureYouWantToWithdrawThisContract: <img src={DeleteContractIcon} alt="icon" />,
  theLegalityOfThisDocumentisYourResponsibility: <img src={CautionIcon} alt="icon" />,
  areYouSureYouWantToVoidThisDocument: <img src={DeleteContractIcon} alt="icon" />,
  areYouSureYouWantToVoidAllDocuments: <img src={DeleteContractIcon} alt="icon" />,
  sendDocument: <img src={CautionIcon} alt="icon" />,
  areYouSure: <img src={CautionIcon} alt="icon" />
}

const confirmCtaIcons = {
  trash: <img src={TrashRedIcon} style={{ marginRight: '10px' }} alt="icon" />
}
const cancelCtaIcons = {
  upload: <img src={UploadDocumentIcon} style={{ marginRight: '10px' }} alt="icon" />
}

const DocumentModal = object => {
  const { close } = useModalize()
  const {
    title,
    content,
    confirmCta,
    cancelCta,
    confirmOnClick = noop,
    cancelOnClick = noop,
    cancelCtaIcon,
    backgroundColor,
    confirmCtaIcon,
    cancelTheme,
    confirmTheme
  } = object
  const id = camelCase(title)

  const handleCancel = () => {
    cancelOnClick()
    close()
  }

  const handleConfirm = () => {
    confirmOnClick()
    close()
  }

  return (
    <Container>
      <IconWrapper backgroundColor={backgroundColor}>{icons[id]}</IconWrapper>
      <TextWrapper>
        <Title>{title}</Title>
        {typeof content !== 'string' ? <>{content}</> : <Paragraph>{content}</Paragraph>}
        <ButtonWrapper>
          {!cancelCta ? (
            <Button theme={confirmTheme} onClick={handleConfirm} width="100%">
              {confirmCta}
            </Button>
          ) : (
            <>
              <Button theme={cancelTheme} onClick={handleCancel}>
                {cancelCtaIcons[cancelCtaIcon]}
                {cancelCta}
              </Button>
              <Button onClick={handleConfirm} theme={confirmTheme}>
                {confirmCtaIcons[confirmCtaIcon]}
                {confirmCta}
              </Button>
            </>
          )}
        </ButtonWrapper>
      </TextWrapper>
    </Container>
  )
}

export const showDocumentModal = createModal(DocumentModal, { showClose: false })
